// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"18e94b57","174":"d5a5c377","326":"040d1743","469":"079dd22d","486":"48a53b35","548":"93485423","561":"d4afb572","753":"2a418352","902":"0cab2855","972":"8f45d35d"}[chunkId] + ".chunk.js";
};